import { render } from "./BaseFormSection.vue?vue&type=template&id=37955c05&scoped=true"
import script from "./BaseFormSection.vue?vue&type=script&lang=js"
export * from "./BaseFormSection.vue?vue&type=script&lang=js"

import "./BaseFormSection.vue?vue&type=style&index=0&id=37955c05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37955c05"]])

export default __exports__